module.exports = __webpack_public_path__ + "img/box-inside1.87a88578.jpg";